import "./Engagement.scss";
import { useNavigate } from "react-router-dom";

const Engagement = () => {
  const navigate = useNavigate();

  return (
    <div className="engagement">
      <div>
        <div className="img-container">
          <div>
            <img src="/images/engagement.png" alt="engagement" />
          </div>
        </div>
        <div>
          <h2>Notre engagement</h2>
          <p>
            Soucieux de s'inscrire dans une démarche responsable, nous avons
            pour objectif de réduire notre empreinte environnementale en nous
            engageant à plusieurs niveaux. <br />
            <br />
            Cela se traduit par une orientation de nos méthodes de travail vers
            les alternatives ayant un impact limité sur l'environnement et les
            personnes.
          </p>
          <div className="buttons">
            <button onClick={() => navigate("/commitment")}>
              En savoir plus
            </button>
            <button onClick={() => navigate("/commitment")}>
              Nos produits Ecolabel
            </button>
            <button onClick={() => navigate("/commitment")}>
              Nos produits recyclés
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Engagement;
